import IconButton from '@components/v2/ui/IconButton/IconButton';
import { ElementType, MouseEvent } from 'react';
import { useMediaOverlayIconButtonStyles } from './mediaOverlayIconButton.styles';

interface MediaOverlayIconButtonProps {
  icon: ElementType;
  ariaLabel: string;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  outlined?: boolean;
  className?: string;
  testId?: string;
  tabIndex?: number;
}

const MediaOverlayIconButton = ({
  icon,
  ariaLabel,
  onClick,
  outlined = true,
  className,
  testId,
  tabIndex,
}: MediaOverlayIconButtonProps) => {
  const { classes, cx } = useMediaOverlayIconButtonStyles();

  return (
    <IconButton
      icon={icon}
      size="large"
      shape="round"
      tabIndex={tabIndex}
      testId={testId}
      ariaLabel={ariaLabel}
      className={cx(classes.control, outlined && classes.outlined, className)}
      onClick={onClick}
    />
  );
};

export default MediaOverlayIconButton;
